import { Tooltip } from "@chakra-ui/react";
import React from "react";
import { ErrorIcon } from "shared/icons/ErrorIcon";

export interface SimpleInputErrorElementProps {
  error: string;
}

export const SimpleInputErrorElement: React.FC<
  SimpleInputErrorElementProps
> = ({ error }) => (
  <Tooltip bg="red.600" color="white" label={error} openDelay={0}>
    <ErrorIcon color="error.700" w="24px" h="24px" />
  </Tooltip>
);
